import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get a specific project
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetProject = packet => {
  return {
    type: 'REQUEST_GET_PROJECT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetProjectSuccess = data => ({
  type: 'RECEIVE_GET_PROJECT_SUCCESS',
  data
})

export const receiveGetProjectFail = data => ({
  type: 'RECEIVE_GET_PROJECT_FAIL',
  data
})

export const tryToGetProject = packet => (dispatch, getState) => {

  dispatch(requestGetProject(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/projects/' + packet.id, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetProjectSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetProjectFail({errors:e, lastSubmit: packet}));
    })
}
